// Why Choose Us section images - embedded base64 (CDN SSL workaround)

export const MASCOT = '/img/whychooseus-mascot.webp';
export const TRUCK = '/img/whychooseus-truck.webp';
export const EQUIPMENT = '/img/whychooseus-equipment.webp';
export const TEAM = '/img/whychooseus-team.webp';
export const MASCOT_CHAR = '/img/whychooseus-mascot_char.webp';
export const MASCOT_ALT = '/img/whychooseus-mascot_alt.webp';